import React from "react";
import { Helmet } from "react-helmet";
import Favicon from "../assets/favicon.ico";

export default function ReactHelmet({ titleName = "", canonical = "", description = "" }) {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>BANDWITT {`${titleName && titleName}`} </title>
      <meta name="google-site-verification" content="iFSK-Ly9aZtNkBbGdkDA1S4tyKk5Q6Laa7JOAM8eNJo" />
      <link rel="icon" type="image/png" href={Favicon} />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta name="theme-color" content="#ffffff" />
      <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.2.1/css/bootstrap.min.css" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />
      <meta name="description" content={description} />
      <meta property="og:locale" content="tr_TR" />
      <link rel="canonical" href={`https://bandwitt.com/${canonical}`} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={`${titleName && titleName + " | "}Bandwitt`} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content="https://bandwitt.com/" />
      <meta property="og:site_name" content="Bandwitt" />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="article:modified_time" content="2021-09-18T18:14:22+00:00" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:label1" content="Tahmini okuma süresi" />
      <meta name="twitter:data1" content="6 dakika" />
      <link rel="alternate" hreflang="en" href="https://bandwitt.com/en" />
      <link rel="alternate" hreflang="tr" href="https://bandwitt.com/" />
    </Helmet>
  );
}
